// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__e_Hf1","box":"WorkspacesBox_box__28-ny","node":"WorkspacesBox_node__JAi3E"};